import { createStore } from "redux";
import { combineReducers } from "redux";
import { insights } from "./reducers/insights";
import { cards } from "./reducers/cards";
import { tagFilter, topicFilter } from "./reducers/tagFilter";
import { setCardsJson, setInsightsJson } from "./actions/actions";

const rootReducer = combineReducers({
  insights,
  cards,
  tagFilter,
  topicFilter
});

const store = createStore(
  rootReducer,
  window.devToolsExtension ? window.devToolsExtension() : f => f
);

store.dispatch(
  setInsightsJson(JSON.parse(window.drupalSettings.mw_hub.json_data).insights)
);
store.dispatch(
  setCardsJson(JSON.parse(window.drupalSettings.mw_hub.json_data).layout)
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js